import React, { Component } from 'react';
import { connect } from 'react-redux';
import createSelector from 'helpers/createSelector';
import _ from 'lodash';
import classnames from 'classnames';
import moment from 'moment';
import { updateQuery } from 'modules/router/actions';

import { Icon, message, Button } from 'antd';

const container = connect(
  createSelector(
    (state) => ({
      query: _.get(state, 'router.location.query'),
      pathname: _.get(state, 'router.location.pathname'),
    }),
    (state) => {
      const { query, pathname } = state;
      const router = pathname.split('/')[1];
      const { q } = query;
      return ({
        q,
        router
      })
    }
  )
)

class KeywordPanel extends Component {

  state = {
    showInput: false
  }

  handleEnter = (e) => {
    if (e.which === 13) {
      this.handleCheck();
      this.setState({
        showInput: false
      })
    }
  };

  handleCheck = () => {
    const {dispatch, q} = this.props;
    const input = this.refs.q.value;
    if (input === '') return;
    if (_.indexOf([].concat(q), input) !== -1) {
      return message.warning(t('subjectKeywordExisted'))
    };

    const qlist = _.compact([].concat(q).concat(input));
    dispatch(updateQuery({
      q: qlist,
    }));

    this.refs.q.value = '';
  };

  handelDeleteQ = (keyword) => {
    const { dispatch, q } = this.props;
    const result = _.without([].concat(q), keyword);

    dispatch(updateQuery({
      q: result,
    }));
  };

  addKeyword = () => {
    this.setState({
      showInput: true
    })
  }

  render() {
    const { q,router } = this.props;

    const qlist = _.compact([].concat(q));
    return (
      <div className="query-panel-header">
        {!_.isEmpty(qlist) && <div className="margin-bottom-sm">{t('commonKeyword')}：</div>}
        {!_.isEmpty(qlist) &&
          <div>
            <div className="query-q-holder">
              {
                _.map(qlist, (keyword, i) => {
                  return (
                    <span key={i} className="q-holder">
                      <span className="q">{keyword}</span>
                      <span
                        className="delete-q"
                        onClick={() => this.handelDeleteQ(keyword)}
                      >
                        <Icon type="cross" />
                      </span>
                    </span>
                  )
                })
              }
            </div>
          </div>
        }
      </div>

    )
  }
}

export default container(KeywordPanel);



/** WEBPACK FOOTER **
 ** ./src/app/modules/controlPanel/components/KeywordPanel.js
 **/